<template>
  <div
    data-qa="appointment_express_only_phone"
    class="text-center py-6 elevation-1 rounded-sm"
  >
    <div class="text-body-1 text-secondary--text mb-1">
      {{ t('Запись по телефону', options) }}
    </div>
    <a
      v-if="isMobile"
      class="text-h4 primary--text text-decoration-none"
      :href="`tel:${lpuDataStore.phoneRaw}`"
    >
      {{ lpuDataStore.phonePublic }}
    </a>
    <div
      v-else
      class="text-h3 text--text"
    >
      {{ lpuDataStore.phonePublic }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import useLpuDataStore from 'www/vue_components/common/AppointmentPage/stores/useLpuDataStore'

const { t, language } = I18NextVue
const options = { ns: language }

const isMobile = window.MOBILE_VERSION

const lpuDataStore = useLpuDataStore()
</script>
